import { createConsentApi } from './api/index';

export function setupSccApi(window, config) {
    window._scc_ = createConsentApi(window, config);
}
